import { camelCase } from "lodash-es";

// only get vue keys
const viteKeys = Object.keys(import.meta.env).filter((key) =>
  key.startsWith("VITE_")
);

interface EnvOptions {
  version: string;
  platformUrl: string; // begins with https://...
  expirationDate: string; // YYYY-MM-DD HH:SS:MM
  saveLocation: "online" | "local";
  expires: boolean;
  tokenRequired: boolean;
  synchronizeSaves: boolean;
  fixedModel: boolean;
  isElectron: boolean;
  saveLocally: boolean;
  isDev: boolean;
  mode: string;
  openModelsInNewTab: boolean;
  locale: string;
  fallbackLocale: string;

  production: boolean;

  baseUrl: string;

  stripePublicKey: string;
  matomoUrl: string;
  matomoSiteId: string;
}

function collectEnvOptions(): EnvOptions {
  return viteKeys.reduce((opts, key) => {
    // gather the keys, removing the prefix and transforming them to camelCase.

    let value = import.meta.env[key];
    if (value && value.toLowerCase() === "true") value = true;
    else if (value && value.toLowerCase() === "false") value = false;

    // transform the env values: e.g.: VITE_EXPIRATION_DATE -> expirationDate
    const newIndex = camelCase(key.substring(5)) as keyof EnvOptions;
    return { ...opts, [newIndex]: value };
  }, {} as EnvOptions);
}

const envOptions = collectEnvOptions();

envOptions.saveLocally = envOptions.saveLocation === "local";
if (!envOptions.saveLocally) {
  envOptions.synchronizeSaves = false;
}

envOptions.version = __APP_VERSION__;
envOptions.baseUrl = import.meta.env.BASE_URL;

// Set the isElectron property automatically if electron is available.
envOptions.isElectron =
  window != null && "electron" in window && window.electron != null;

envOptions.mode = import.meta.env.MODE;
envOptions.isDev = import.meta.env.DEV;

envOptions.production = !["devapp", "alphaapp", "betaapp", "localapp", "web-development", "web-alpha", "web-beta"].includes(import.meta.env.MODE);

console.log("env", envOptions);

export default envOptions;
